import NewArrivals from "./NewArrivals";

function Men(){
    return(
        
        <div>
            <NewArrivals/>
        </div>
        
    )
}
export default Men;